module.exports = __webpack_public_path__ + "img/gettyimages-medium.902c844f.png";